import React from 'react'
import { get } from 'lodash'
import * as Accessa from 'accessa'
import Box from '@material-ui/core/Box'
import Breadcrumbs from './Breadcrumbs'

const Hero = (props) => (
  <Accessa.Headers.Mast
    title={get(props, 'hero.title')}
    fluid={get(props, 'hero.image.fluid')}
    renderBottom={
      <Box mt={3}>
        <Breadcrumbs
          justifyContent="center"
          title={get(props, 'hero.title')}
        />
      </Box>
    }
    renderTop={<Box mt={18} />}
  />
)

Hero.propTypes = {}

export default Hero
